// extracted by mini-css-extract-plugin
export var hero = "Hq9Ca2n1KU2wMXdo3HWQ";
export var root = "YJfyfIlyBlb1kBjFhlpU";
export var title1 = "VrvTkf0gb_E_xtNd9bUb";
export var title2 = "kWQ25dgiicUpmtCD9VXv";
export var title3 = "VXAOiybMkmiA6KPvmPS_";